import { render, staticRenderFns } from "./FlashCard.vue?vue&type=template&id=2a9a459f&scoped=true&"
import script from "./FlashCard.vue?vue&type=script&lang=js&"
export * from "./FlashCard.vue?vue&type=script&lang=js&"
import style0 from "./FlashCard.vue?vue&type=style&index=0&id=2a9a459f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9a459f",
  null
  
)

component.options.__file = "FlashCard.vue"
export default component.exports